var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAltArrowLeftRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3254 2.95388C10.5351 3.13359 10.5593 3.44924 10.3796 3.6589L6.65854 8.00017L10.3796 12.3414C10.5593 12.5511 10.5351 12.8668 10.3254 13.0465C10.1157 13.2262 9.80008 13.2019 9.62037 12.9922L5.62037 8.32557C5.45988 8.13832 5.45988 7.86202 5.62037 7.67478L9.62037 3.00811C9.80008 2.79845 10.1157 2.77417 10.3254 2.95388Z",
    fill: "#CA1515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltArrowLeftRed);
export default __webpack_public_path__ + "static/media/altArrowLeftRed.b77ca4db3a6b4fb0fc78c33b66993cf6.svg";
export { ForwardRef as ReactComponent };